import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import useApiFetcher from "../../hooks/useApiFetcher";
import styles from "./ModalForm.module.css"; // Import the module CSS
import { toast } from "react-toastify";
import imageCompression from "browser-image-compression";
import axios from "axios";


const ModalForm = ({
  isOpen,
  onClose,
  sentence,
  setSentences,
  formData,
  setFormData,
  currentIndex,
  setCurrentIndex,
  tableIndex,
  setTableIndex,
  steps,
  setSteps,
  setshowAddNotepadBtn,
  showAddNotepadBtn
}) => {
  const { apiFetcher } = useApiFetcher();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  console.log(currentIndex, "currentIndex")

  if (!isOpen || !mounted) return null; // Do not render the modal if `isOpen` is false
  const isLastSentence = steps[tableIndex]?.boardData.length - 1 === currentIndex;
  console.log(isLastSentence, "isLastSentence");

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevFormData) => {
      // If checkbox is unchecked, clear the buttonText
      if (name === "isButton" && !checked) {
        return {
          ...prevFormData,
          [name]: checked,
          buttonText: "", // Clear the buttonText when the checkbox is unchecked
        };
      }
      return {
        ...prevFormData,
        [name]: type === "checkbox" ? checked : value,
      };
    });
  };

  const handleImageTitleChange = (e, index) => {
    const { value } = e.target;
    const updatedImages = [...(formData?.images || [])];
    updatedImages[index].imgTitle = value;
    setFormData({ ...formData, images: updatedImages });
  };

  const handleImageChange = async (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    // Compression options
    const options = {
      maxSizeMB: 1, // Max file size in MB
      maxWidthOrHeight: 800, // Max width or height in pixels
      useWebWorker: true, // Use web workers for faster compression
    };

    try {
      const compressedFile = await imageCompression(file, options);

      const formData2 = new FormData();
      formData2.append("image", compressedFile);

      const presignedUrl = await apiFetcher("/multi-stepper/upload", "POST", { key: 'test' });
      const uploadResponse = await axios.put(presignedUrl, compressedFile, {
        headers: {
          "Content-Type": 'multipart/form-data',
        },
      });

      const objectViewUrl = presignedUrl.split('?X-Amz-Algorithm')[0];

      const updatedImages = [...(formData?.images || [])];
      updatedImages[index].image = objectViewUrl;

      setFormData({ ...formData, images: updatedImages });
    } catch (error) {
      console.error("Error compressing or uploading image:", error);
    }
  };

  const addMoreImages = () => {
    if ((formData?.images || []).length < 3) {
      setFormData({
        ...formData,
        images: [...(formData?.images || []), { imgTitle: "", image: null }],
      });
    }
  };

  const removeImageField = (index) => {
    const updatedImages = (formData?.images || []).filter((_, i) => i !== index);
    setFormData({ ...formData, images: updatedImages });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (isLastSentence && (!formData.buttonText || formData.buttonText.trim() === "")) {
    //   alert(`Please add Button Text for the last sentence in Table ${tableIndex + 1}.`);
    //   return;
    // }
    console.log("handleSubmit called");
    setshowAddNotepadBtn(false)
    try {
      const notepadData = { ...formData };

      const updatedStepsData = [...steps];
      updatedStepsData[tableIndex].boardData[currentIndex].notepadData = formData;
      updatedStepsData[tableIndex].boardData[currentIndex].boardDataAdded = true
      setSteps(updatedStepsData);

      onClose(); // Close the modal

      setFormData({
        selectedSentence: "",
        heading: "",
        subHeading: "",
        content: "",
        images: [{ imgTitle: "", image: null }],
      });

      const handleNotification = () => {
        toast.success("Data added successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      };

      handleNotification();
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  return createPortal(
    <div className={styles.modalOverlay} style={{ zIndex: 999999 }}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2>Add Note</h2>
          <button onClick={onClose} className={styles.closeBtn}>
            ✖
          </button>
        </div>
        <form onSubmit={handleSubmit} className={styles.modalForm}>
          {/* Heading */}
          <div className={styles.formGroupforinput}>
            <div className={styles.forminput}>
              <label>Heading</label>
              <textarea
                type="text"
                name="heading"
                placeholder="Heading"
                rows="2"
                maxLength={50}
                value={formData?.heading || ""}
                onChange={handleInputChange}
              />
            </div>
            <div className={styles.forminput}>
              <label>Sub heading</label>
              <textarea
                type="text"
                name="subHeading"
                maxLength={90}
                placeholder="Sub heading"
                value={formData?.subHeading || ""}
                onChange={handleInputChange}
              />
            </div>
          </div>

          {/* Content */}
          <div className={styles.formGroup}>
            <label>Content</label>
            <textarea
              name="content"
              maxLength={250}
              placeholder="Content"
              value={formData?.content || ""}
              onChange={handleInputChange}
            ></textarea>
          </div>

          {/* fields for button adding text */}

          {/* <label className={styles.checkbox_container}>
            <input
              type="checkbox"
              name="isButton"
              checked={formData?.isButton || false}
              onChange={handleInputChange}
              className={styles.checkbox}
            />
            Include Button
          </label>
          {formData?.isButton && (
            <input
              type="text"
              name="buttonText"
              maxLength={20}
              placeholder="Button Text"
              value={formData?.buttonText || ""}
              onChange={handleInputChange}
              className={styles.text_input}
            />
          )} */}


          {/* Image Upload */}
          {(formData?.images || []).map((img, index) => (
            <div key={index} className={styles.formGroup}>
              <div className={styles.imageFields}>
                <input
                  type="text"
                  placeholder="Image Title"
                  value={img.imgTitle || ""}
                  onChange={(e) => handleImageTitleChange(e, index)}
                />
                <input
                  type="file"
                  maxLength={20}
                  accept="image/*"
                  onChange={(e) => handleImageChange(e, index)}
                />

                {img.image && (
                  <div className={styles.imagePreview}>
                    <img
                      src={img?.image}
                      alt={img.imgTitle || "Uploaded Image"}
                      className={styles.uploadedImage}
                    />
                  </div>
                )}
                <button
                  type="button"
                  onClick={() => removeImageField(index)}
                  className={styles.removeBtn}
                >
                  Remove
                </button>
              </div>
            </div>
          ))}

          <button
            type="button"
            onClick={addMoreImages}
            className={styles.moreImgsBtn}
            disabled={(formData?.images || []).length >= 3}
            style={{
              backgroundColor: (formData?.images || []).length >= 3 ? "gray" : "",
              cursor: (formData?.images || []).length >= 3 ? "not-allowed" : "pointer",
            }}
          >
            Add more images
          </button>
          <button type="submit" className={styles.submitBtn}>
            Submit
          </button>
        </form>
      </div>


    </div>,
    document.body
  );
};

export default ModalForm;
